import { Link } from 'react-router-dom';

const stats = [
  { number: '15+', label: '年專業經驗' },
  { number: '500+', label: '服務客戶' },
  { number: '98%', label: '客戶滿意度' },
];

const credentials = ['RFC 認證理財顧問', 'CFP 國際認證', '人壽保險業務員', '產物保險業務員'];

export default function AboutPreview() {
  return (
    <section className="bg-[#0F2847] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left: Photo */}
          <div className="w-full lg:w-[45%] flex-shrink-0">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden aspect-[4/5] max-w-md mx-auto lg:mx-0">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20asian%20male%20insurance%20financial%20advisor%20in%20formal%20business%20suit%20standing%20confident%20in%20modern%20office%20interior%20warm%20lighting%20clean%20background%20portrait%20photography&width=600&height=750&seq=about001&orientation=portrait"
                  alt="陳琮恩 保險建築師"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Name Card Overlay */}
              <div className="absolute bottom-6 left-6 right-6 bg-[#0F2847]/90 backdrop-blur-sm rounded-xl p-5 border border-white/10">
                <p className="font-serif font-bold text-white" style={{ fontSize: '1.625rem', lineHeight: '1.3' }}>陳琮恩</p>
                <p className="text-[#C9A84C] mt-1" style={{ fontSize: '1.1875rem' }}>資深保險規劃師</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {credentials.map((c) => (
                    <span
                      key={c}
                      className="border border-white/30 text-white/80 px-2.5 py-0.5 rounded-full"
                      style={{ fontSize: '1rem' }}
                    >
                      {c}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-[55%]">
            <p className="text-[#C9A84C] font-semibold tracking-widest mb-4" style={{ fontSize: '1rem' }}>
              ABOUT ME
            </p>
            <h2
              className="font-serif font-bold text-white mb-6"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
            >
              用建築師的精神
              <br />
              為您規劃保障藍圖
            </h2>

            <div className="space-y-5 mb-10">
              <p className="text-white/80" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
                我是陳琮恩，一位擁有超過 15 年保險規劃經驗的專業顧問。就像建築師在動工前必須先繪製精確的藍圖，我相信每一份保險規劃都需要嚴謹的設計與深思熟慮的佈局。
              </p>
              <p className="text-white/80" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
                我的服務不只是銷售保單，而是成為您人生各階段的保障顧問。從新婚、生子、購屋到退休，每一個重要時刻，我都陪伴在您身旁，確保您的保障與人生同步成長。
              </p>
              <p className="text-white/80" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
                超過 500 位客戶的信任，是我最大的動力。我承諾以最高的專業標準與最真誠的服務態度，為您打造最堅固的保障基礎。
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-10">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-white/8 rounded-xl p-5 text-center border border-white/10">
                  <div
                    className="font-serif font-bold text-[#C9A84C]"
                    style={{ fontSize: '2.125rem', lineHeight: '1.2' }}
                  >
                    {stat.number}
                  </div>
                  <div className="text-white/70 mt-1" style={{ fontSize: '1rem' }}>{stat.label}</div>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-[#C9A84C] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#b8943e] transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              深入了解琮恩
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
